/** A non-empty string, trimmed, or null for a missing, empty or blank one. */
export function present(value: string | null | undefined): string | null {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
}
